// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y8PHp9 {
  display: flex;
  flex-direction: column;
  flex: 1;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  background-color: var(--background-white);
}

.fcZXrL {
  display: flex;
  flex-grow: 1;
  padding: 20px 10px 20px 24px;
  overflow: hidden;
}

.uKoyzm {
  display: flex;
  align-items: center;
  padding-top: 1px;
}
.humxd5 {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

._0yKnV {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-1, 8px);
  margin-bottom: var(--spacing-3, 16px);
}

.OKap2k {
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-primary-medium);
  transition: color 0.2s ease;
}

.OKap2k:hover {
  color: var(--text-primary-medium);
  opacity: 0.8;
}

.OKap2k:focus {
  outline: 2px solid var(--text-primary-medium);
  outline-offset: 2px;
  border-radius: 2px;
}

.lvGkHH {
  display: flex;
  flex-direction: column;
  gap: 0;
  background-color: var(--background-white);
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  margin-bottom: 0;
}

.g6fg00 {
  display: flex;
  align-items: center;
  gap: var(--spacing-2, 12px);
  padding-bottom: 0;
}

.xbgM34,
.F6aIdg {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: transparent;
  object-fit: contain;
  flex-shrink: 0;
}

.F6aIdg {
  padding: 0;
}

.Zd7Wxo {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
  flex: 1;
}

.WVcxz0 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  line-height: 1.4;
}

.lWMMdM {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.4;
}

.wlc3wl {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.4;
}

.yi84fW {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
  margin-top: var(--spacing-2, 12px);
}

.Qjszxw {
  margin: 0;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  font-weight: var(--font-weight-regular);
  line-height: 1.4;
}

.jO2Hs9 {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  line-height: 1.2;
}

.tJ1a1f {
  flex: 1;
  overflow-y: auto;
  overflow-anchor: auto;
  padding-top: var(--spacing-1);
  margin: 0 calc(var(--spacing-3, 16px) * -1);
  margin-left: 0;
  margin-right: 0;
  margin-top: var(--spacing-3, 16px);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 16px);
  background-color: var(--background-white);
}

.Q_SB0s {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.rWyXxX {
  margin: 0;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  line-height: 1.4;
}

.gYXI7H {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.nzFuBF {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  background-color: var(--surface-neutral-pale);
  border-radius: 12px;
  padding: var(--spacing-2, 16px);
  height: 82px;
}

.gqawmo {
  width: 34px;
  height: 34px;
  border-radius: 18px;
  background-color: var(--background-white);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.gqawmo.ckZi2K {
  background-color: var(--success-green-light);
}

.Yk7lmH {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.u8eiXv {
  color: var(--text-secondary);
}

.ckZi2K {
  color: var(--success-green-dark);
}

.W6wfLr {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
  min-width: 0;
  height: 100%;
}

.cSIIFn {
  margin: 0;
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  line-height: 1.4;
}

.M1KkUx {
  margin: 0;
  font-size: var(--font-size-md, 14px);
  color: var(--text-secondary);
  font-weight: var(--font-weight-regular);
  line-height: 1.4;
}

.pG4u44 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}

.EX6MvH {
  margin: 0;
  font-size: var(--font-size-sm, 14px);
  font-weight: var(--font-weight-semibold);
  line-height: 1.4;
}

.TMJXSq {
  color: var(--success-green-dark);
}

.DZQ_cS {
  color: var(--text-secondary);
}

.Oo9ti4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-4, 32px);
  color: var(--text-secondary);
  text-align: center;
}

.Vnmqsp {
  margin: 0;
  font-size: var(--font-size-md);
}

.B_mQqm {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-3, 16px);
}

@media (max-width: 768px) {
  .h2OPxu {
    padding: var(--spacing-3, 16px);
  }

  .tJ1a1f {
    padding: var(--spacing-3, 16px);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/contabilidade-digital/src/pages/ContabilidadeDigitalDasboard/components/AccountTransactions/AccountTransactions.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qDAAqD;EACrD,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,OAAO;AACT;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,4BAA4B;EAC5B,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,4BAA4B;EAC5B,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  box-sizing: border-box;\n  height: 100%;\n  overflow: hidden;\n  background-color: var(--background-white);\n}\n\n.drawerBody {\n  display: flex;\n  flex-grow: 1;\n  padding: 20px 10px 20px 24px;\n  overflow: hidden;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  padding-top: 1px;\n}\n.headerTitle {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  margin-bottom: var(--spacing-3, 16px);\n}\n\n.clearFiltersButton {\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-primary-medium);\n  transition: color 0.2s ease;\n}\n\n.clearFiltersButton:hover {\n  color: var(--text-primary-medium);\n  opacity: 0.8;\n}\n\n.clearFiltersButton:focus {\n  outline: 2px solid var(--text-primary-medium);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.accountCard {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  background-color: var(--background-white);\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n  margin-bottom: 0;\n}\n\n.accountHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2, 12px);\n  padding-bottom: 0;\n}\n\n.accountLogo,\n.accountLogoFallback {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: transparent;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.accountLogoFallback {\n  padding: 0;\n}\n\n.accountInfo {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n  flex: 1;\n}\n\n.accountBank {\n  margin: 0;\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n  line-height: 1.4;\n}\n\n.accountHolder {\n  margin: 0;\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n.accountNumber {\n  margin: 0;\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n.balanceSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n  margin-top: var(--spacing-2, 12px);\n}\n\n.balanceLabel {\n  margin: 0;\n  font-size: var(--font-size-md);\n  color: var(--text-secondary);\n  font-weight: var(--font-weight-regular);\n  line-height: 1.4;\n}\n\n.balanceValue {\n  margin: 0;\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--text-primary);\n  line-height: 1.2;\n}\n\n.groups {\n  flex: 1;\n  overflow-y: auto;\n  overflow-anchor: auto;\n  padding-top: var(--spacing-1);\n  margin: 0 calc(var(--spacing-3, 16px) * -1);\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: var(--spacing-3, 16px);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 16px);\n  background-color: var(--background-white);\n}\n\n.group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.groupLabel {\n  margin: 0;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n  line-height: 1.4;\n}\n\n.groupList {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.transactionCard {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  background-color: var(--surface-neutral-pale);\n  border-radius: 12px;\n  padding: var(--spacing-2, 16px);\n  height: 82px;\n}\n\n.transactionIconWrapper {\n  width: 34px;\n  height: 34px;\n  border-radius: 18px;\n  background-color: var(--background-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.transactionIconWrapper.transactionIconCredit {\n  background-color: var(--success-green-light);\n}\n\n.transactionIcon {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n}\n\n.transactionIconDebit {\n  color: var(--text-secondary);\n}\n\n.transactionIconCredit {\n  color: var(--success-green-dark);\n}\n\n.transactionInfo {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n  min-width: 0;\n  height: 100%;\n}\n\n.transactionTitle {\n  margin: 0;\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n  line-height: 1.4;\n}\n\n.transactionSubtitle {\n  margin: 0;\n  font-size: var(--font-size-md, 14px);\n  color: var(--text-secondary);\n  font-weight: var(--font-weight-regular);\n  line-height: 1.4;\n}\n\n.transactionAmountWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n\n.transactionAmount {\n  margin: 0;\n  font-size: var(--font-size-sm, 14px);\n  font-weight: var(--font-weight-semibold);\n  line-height: 1.4;\n}\n\n.credit {\n  color: var(--success-green-dark);\n}\n\n.debit {\n  color: var(--text-secondary);\n}\n\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-4, 32px);\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.emptyStateText {\n  margin: 0;\n  font-size: var(--font-size-md);\n}\n\n.loadingMore {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-3, 16px);\n}\n\n@media (max-width: 768px) {\n  .header {\n    padding: var(--spacing-3, 16px);\n  }\n\n  .groups {\n    padding: var(--spacing-3, 16px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Y8PHp9`,
	"drawerBody": `fcZXrL`,
	"headerLeft": `uKoyzm`,
	"headerTitle": `humxd5`,
	"filters": `_0yKnV`,
	"clearFiltersButton": `OKap2k`,
	"accountCard": `lvGkHH`,
	"accountHeader": `g6fg00`,
	"accountLogo": `xbgM34`,
	"accountLogoFallback": `F6aIdg`,
	"accountInfo": `Zd7Wxo`,
	"accountBank": `WVcxz0`,
	"accountHolder": `lWMMdM`,
	"accountNumber": `wlc3wl`,
	"balanceSection": `yi84fW`,
	"balanceLabel": `Qjszxw`,
	"balanceValue": `jO2Hs9`,
	"groups": `tJ1a1f`,
	"group": `Q_SB0s`,
	"groupLabel": `rWyXxX`,
	"groupList": `gYXI7H`,
	"transactionCard": `nzFuBF`,
	"transactionIconWrapper": `gqawmo`,
	"transactionIconCredit": `ckZi2K`,
	"transactionIcon": `Yk7lmH`,
	"transactionIconDebit": `u8eiXv`,
	"transactionInfo": `W6wfLr`,
	"transactionTitle": `cSIIFn`,
	"transactionSubtitle": `M1KkUx`,
	"transactionAmountWrapper": `pG4u44`,
	"transactionAmount": `EX6MvH`,
	"credit": `TMJXSq`,
	"debit": `DZQ_cS`,
	"emptyState": `Oo9ti4`,
	"emptyStateText": `Vnmqsp`,
	"loadingMore": `B_mQqm`,
	"header": `h2OPxu`
};
module.exports = ___CSS_LOADER_EXPORT___;
